var map = {
	"./age_group_1_1.webp": "./src/assets/image/template/age_group_1_1.webp",
	"./age_group_1_2.webp": "./src/assets/image/template/age_group_1_2.webp",
	"./age_group_1_3.webp": "./src/assets/image/template/age_group_1_3.webp",
	"./age_group_1_4.webp": "./src/assets/image/template/age_group_1_4.webp",
	"./age_group_2_1.webp": "./src/assets/image/template/age_group_2_1.webp",
	"./age_group_2_2.webp": "./src/assets/image/template/age_group_2_2.webp",
	"./age_group_2_3.webp": "./src/assets/image/template/age_group_2_3.webp",
	"./age_group_2_4.webp": "./src/assets/image/template/age_group_2_4.webp",
	"./age_group_3_1.webp": "./src/assets/image/template/age_group_3_1.webp",
	"./age_group_3_2.webp": "./src/assets/image/template/age_group_3_2.webp",
	"./age_group_3_3.webp": "./src/assets/image/template/age_group_3_3.webp",
	"./age_group_3_4.webp": "./src/assets/image/template/age_group_3_4.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/template sync recursive ^\\.\\/.*_.*\\.webp$";